"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var dynamic_form_item_service_1 = require("app/main/content/_service/dynamic-form-item.service");
var dynamic_form_item_control_service_1 = require("app/main/content/_service/dynamic-form-item-control.service");
var material_1 = require("@angular/material");
var class_definition_service_1 = require("app/main/content/_service/meta/core/class/class-definition.service");
var util_1 = require("util");
var ClassInstanceFormPreviewDialogComponent = /** @class */ (function () {
    function ClassInstanceFormPreviewDialogComponent(dialogRef, data, classDefinitionService, formItemService, formItemControlService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.classDefinitionService = classDefinitionService;
        this.formItemService = formItemService;
        this.formItemControlService = formItemControlService;
        this.isLoaded = false;
    }
    ClassInstanceFormPreviewDialogComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.returnedClassInstances = [];
                this.classDefinitionService
                    .getFormConfigurationPreview(this.data.classDefinitions, this.data.relationships, this.data.rootClassDefinition)
                    .toPromise()
                    .then(function (ret) {
                    var e_1, _a;
                    _this.formConfigurations = ret;
                    try {
                        for (var _b = __values(_this.formConfigurations), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var config = _c.value;
                            config.formEntry = _this.addQuestionsAndFormGroup(config.formEntry, config.formEntry.classDefinitions[0].id + '.');
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }).then(function () {
                    _this.currentFormConfiguration = _this.formConfigurations.pop();
                    _this.isLoaded = true;
                });
                return [2 /*return*/];
            });
        });
    };
    ClassInstanceFormPreviewDialogComponent.prototype.addQuestionsAndFormGroup = function (formEntry, idPrefix) {
        var e_2, _a;
        formEntry.formItems = this.formItemService.getFormItemsFromProperties(formEntry.classProperties, idPrefix);
        formEntry.formGroup = this.formItemControlService.toFormGroup(formEntry.formItems);
        if (!util_1.isNullOrUndefined(formEntry.subEntries)) {
            try {
                for (var _b = __values(formEntry.subEntries), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var subEntry = _c.value;
                    var newIdPrefix = idPrefix + subEntry.classDefinitions[0].id + '.';
                    subEntry = this.addQuestionsAndFormGroup(subEntry, newIdPrefix);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return formEntry;
    };
    ClassInstanceFormPreviewDialogComponent.prototype.handleResultEvent = function (event) {
    };
    ClassInstanceFormPreviewDialogComponent.prototype.handleCloseClick = function () {
        this.dialogRef.close();
    };
    ClassInstanceFormPreviewDialogComponent.prototype.printAnything = function (anything) {
        console.log(anything);
    };
    ClassInstanceFormPreviewDialogComponent.prototype.navigateBack = function () {
        window.history.back();
    };
    return ClassInstanceFormPreviewDialogComponent;
}());
exports.ClassInstanceFormPreviewDialogComponent = ClassInstanceFormPreviewDialogComponent;
